import { Grid } from "@mui/material";
import React from "react";
import Footer from "../../molecules/footer";
import Navbar from "../../molecules/navbar";
import { makeStyles } from "@mui/styles";
import { useContext } from "react";
import { AppContext } from "../../../context/AppContext";
import Loader from "../../atoms/loader";

const MainLayout = ({ children, componentFlag }) => {
  const classes = useStyles();
  const app = useContext(AppContext);

  const loading = app.appLoadingStates.appLoader;
  return (
    <Grid className={classes.test}>
      <Navbar />
      {loading ? (
        <Grid className={classes.root}>
          <Loader />
        </Grid>
      ) : (
        ""
      )}
      <Grid className={classes.root} style={{ opacity: loading ? 0 : 1 }}>
        {children}
      </Grid>

      <Footer componentFlag={componentFlag} />
    </Grid>
  );
};

const useStyles = makeStyles((theme) => ({
  root: {
    // width: "100vw",
    minHeight: "77vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    // maxWidth: "1400px",
  },
}));

export default MainLayout;
